<template>
    <div class="mc-return-lines">
        <section v-for="(line, index) in lines" :key="line.id" class="mc-return-line" :aria-label="`Riga ${index + 1}`">
            <div class="mc-return-line__head">
                <h3 class="mc-card__title">Riga {{ index + 1 }}</h3>
                <v-btn text :disabled="lines.length === 1" :aria-label="`Elimina riga ${index + 1}`" @click="$emit('remove', index)">
                    <v-icon left>mdi-delete-outline</v-icon>Elimina riga
                </v-btn>
            </div>
            <div>
                <v-row dense>
                    <v-col cols="12" md="8">
                        <v-autocomplete
                            outlined dense hide-details="auto"
                            color="var(--brand)"
                            :menu-props="{ contentClass: 'mc-root mc-customer-return mc-return-menu' }"
                            v-model="line.article"
                            :items="articles"
                            item-value="codice"
                            :item-text="articleLabel"
                            :filter="articleFilter"
                            label="Articolo *"
                            hint="Cerca per codice ME.CO.M., codice cliente o descrizione tra gli articoli consegnati negli ultimi 6 mesi"
                            persistent-hint
                            clearable
                            :disabled="!customerCode"
                            :loading="loadingArticles"
                            no-data-text="Nessun articolo consegnato negli ultimi 6 mesi"
                            @change="onArticleChange(line)"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            outlined dense hide-details="auto"
                            color="var(--brand)"
                            v-model.number="line.quantity"
                            type="number"
                            min="0.001"
                            :max="deliveredQuantity(line.article)"
                            step="0.001"
                            label="Quantità *"
                            :hint="quantityHint(line.article)"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            outlined dense hide-details="auto"
                            color="var(--brand)"
                            :menu-props="{ contentClass: 'mc-root mc-customer-return mc-return-menu' }"
                            v-model="line.managementCode"
                            :items="managementOptions"
                            item-value="code"
                            :item-text="managementLabel"
                            label="Gestione reso *"
                        />
                    </v-col>
                    <v-col v-if="line.description" cols="12" class="py-0">
                        <v-alert dense text type="info">{{ line.description }}</v-alert>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            outlined dense hide-details="auto"
                            color="var(--brand)"
                            v-model.trim="line.problem"
                            rows="2"
                            auto-grow
                            label="Problema segnalato dal cliente *"
                        />
                    </v-col>
                </v-row>
            </div>
        </section>
        <v-btn outlined color="var(--brand-ink)" @click="$emit('add')"><v-icon left>mdi-plus</v-icon>Aggiungi riga</v-btn>
    </div>
</template>

<script>
import { RETURN_MANAGEMENT_OPTIONS } from "./customerReturnDraft.mjs";
import { number } from "@/assets/mecom/js/format.mjs";
import {
    customerReturnArticleLabel,
    matchesCustomerReturnArticle,
} from "./customerReturnArticleSearch.mjs";

export default {
    name: "CustomerReturnLines",
    props: {
        lines: { type: Array, required: true },
        customerCode: { type: String, default: "" },
        articles: { type: Array, default: () => [] },
        loadingArticles: { type: Boolean, default: false },
    },
    data: () => ({
        managementOptions: RETURN_MANAGEMENT_OPTIONS,
    }),
    methods: {
        managementLabel(item) {
            return `${item.code} - ${item.description}`;
        },
        articleLabel(item) {
            return customerReturnArticleLabel(item, (quantity) =>
                this.formatQuantity(quantity)
            );
        },
        articleFilter(item, queryText) {
            return matchesCustomerReturnArticle(item, queryText);
        },
        deliveredQuantity(articleCode) {
            const selectedArticle = this.articles.find((article) => article.codice === articleCode);
            return selectedArticle ? Number(selectedArticle.quantita_consegnata) : undefined;
        },
        quantityHint(articleCode) {
            const quantity = this.deliveredQuantity(articleCode);
            return quantity === undefined ? "" : `Consegnati negli ultimi 6 mesi: ${this.formatQuantity(quantity)}`;
        },
        formatQuantity(quantity) {
            return number(quantity === null || quantity === "" ? null : Number(quantity), 3);
        },
        onArticleChange(line) {
            const selectedArticle = this.articles.find((article) => article.codice === line.article);
            line.description = selectedArticle ? selectedArticle.descrizione : "";
        },
    },
};
</script>
